import { OperationType, ROUTE_PATH } from 'common/constants/sm-constants';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { GridMetaModel,Headers } from 'common/models/utility-models/meta-model';


export class FeedbackMappingGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Feedback Mapping',
            ROUTE_PATH.feedbackMappinggrid,
            ROUTE_PATH.feedbackMapform,
            false,
            false,
            8,

            false,
            true,
            ['title'],
            false,
            [],
            { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
            false,
            null,
            null,
            null,
            false,
            null,
            null,
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            false,
            [],
            true,
            { isExtraActions: false, btnLabel: '', selectOptions: [] },
            { isCheckboxEmit: false, emitKey: '', checkedKey: '', valueKey: '' },
            { isDownload: true, key: null, valueKey: null },
            { isTabStatus: false, label: '', isChecked: false },
            false,
            false
        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const title = new Headers('Title', 'title', false, true, 'text');

        const students = new Headers('Student Count', 'StudentCount', false, false, 'textUrl', '0', {
            isColumnNavigation: true,
            navigationUrl: ROUTE_PATH.feedbackStudentList,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: new WidgetModel()
        });
        const date = new Headers('Date', 'display_datetime', false, false, 'text');
        const formName = new Headers('Form Name', 'formName', false, false, 'text');
        const editTitle = new Headers('Edit Title', 'editTitle', false, false, 'editTitle')
        headers.push(title);
        headers.push(students);
        headers.push(date);
        headers.push(formName);
        headers.push(editTitle);
        return headers;
    }
}